module.exports = __webpack_public_path__ + "img/目标5.8fbe9e88.png";